import React from "react";
import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { businessDetails } from "../data/content";

const ext = { target: "_blank", rel: "noopener noreferrer" };
const linkCls = "font-semibold text-brand-teal underline hover:text-brand-tealHover";

export const CookiePolicyPage = ({ onOpenCookies }) => (
  <LegalLayout
    title="Cookie Policy"
    description="How the Freeman Jones website uses cookies and similar storage, and how to change your cookie preferences."
    path="/cookie-policy"
    updated="September 2026"
    testid="cookie-policy-page"
  >
    <LegalSection id="what-are-cookies" title="What are cookies?">
      <p>
        Cookies are small text files that websites save on your device to remember information
        about your visit. This site also uses your browser's local storage, which works in a
        similar way, to remember your preferences.
      </p>
    </LegalSection>

    <LegalSection id="cookies-we-use" title="The cookies we use">
      <p>
        This site uses one essential item, and analytics cookies only if you choose to accept
        them.
      </p>

      <h3 className="pt-2 font-heading text-sm font-bold uppercase tracking-[0.12em] text-brand-navy">
        Essential
      </h3>
      <p>
        <strong>Cookie preference (fj_cookie_consent)</strong> — stored in your browser's local
        storage, this remembers whether you accepted or rejected analytics cookies so we don't
        ask you again on every visit. It contains no personal information, is essential for the
        cookie banner to work correctly, and remains until you change your preference or clear
        your browser storage.
      </p>

      <h3 className="pt-2 font-heading text-sm font-bold uppercase tracking-[0.12em] text-brand-navy">
        Analytics (optional)
      </h3>
      <p>
        With your consent, we would also like to use analytics cookies to understand how the
        site is used — for example, which pages are visited and which links are clicked.
        Analytics will not load until you accept, and no personal or special-category data is
        ever passed to analytics. If you choose "Essential only", no analytics cookies are set.
      </p>
    </LegalSection>

    <LegalSection id="managing-preferences" title="Managing your preferences">
      <p>You can change your cookie choice at any time using the button below:</p>
      <p>
        <button
          type="button"
          onClick={onOpenCookies}
          data-testid="cookie-policy-manage"
          className="inline-flex min-h-[48px] items-center justify-center rounded-full bg-brand-teal px-6 font-semibold text-white transition-colors hover:bg-brand-tealHover"
        >
          Manage cookie preferences
        </button>
      </p>
      <p>
        You can also control or delete cookies through your browser settings. Please note that
        clearing your browser storage will remove your saved cookie preference, so we will ask
        you again on your next visit.
      </p>
    </LegalSection>

    <LegalSection id="more-information" title="More information">
      <p>
        For details of how we handle personal information, please read our{" "}
        <a {...ext} href={businessDetails.privacyPolicyUrl} className={linkCls}>
          Privacy Policy
        </a>
        .
      </p>
      <p>
        Independent guidance about cookies is available from the{" "}
        <a {...ext} href="https://ico.org.uk/for-the-public/online/cookies/" className={linkCls}>
          Information Commissioner's Office (ICO)
        </a>
        .
      </p>
    </LegalSection>
  </LegalLayout>
);
